export default "__VITE_ASSET__45e8d8cb__"